import {TopicEntity} from "../contract/topic";
import {setEntity, setEntities, createEntityState} from "../helpers/entity";
import {ReducerTypeHelper} from "../helpers/reducer";

const defaultState = createEntityState<TopicEntity>();

const topicsReducer: ReducerTypeHelper<typeof defaultState> = (state = defaultState, action) => {
  switch(action.type) {
    case 'topic/set': {
      return setEntity(state, action.payload);
    }

    case 'topic/setMultiple': {
      return setEntities(state, action.payload);
    }

    default:
      return state;
  }
}

export default topicsReducer;
